"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Search32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M22.358 13.479a8.323 8.323 0 01-.692 3.37 8.924 8.924 0 01-4.671 4.626c-2.115.91-4.699.91-6.796 0a8.969 8.969 0 01-4.657-4.626c-.922-2.107-.929-4.618-.001-6.724a8.908 8.908 0 011.883-2.747A9.012 9.012 0 0110.2 5.513c2.129-.922 4.666-.914 6.796 0a8.947 8.947 0 012.79 1.865 8.892 8.892 0 011.881 2.747 8.232 8.232 0 01.691 3.354zm6.917 14.01l-7.259-7.104a11.047 11.047 0 001.798-3.03c1.018-2.558.965-5.556-.134-8.08a10.708 10.708 0 00-2.359-3.423 10.819 10.819 0 00-3.474-2.339c-2.653-1.128-5.863-1.131-8.498.001a11.175 11.175 0 00-3.486 2.335 10.942 10.942 0 00-2.332 3.425c-1.151 2.642-1.151 5.795 0 8.437a11.312 11.312 0 002.334 3.456c.998.968 2.17 1.744 3.484 2.304 2.529 1.085 5.528 1.142 8.096.15a11.796 11.796 0 003.031-1.72l7.267 7.114c.108.107.23.187.364.24.405.162.891.065 1.199-.24.214-.214.321-.484.308-.776a1.101 1.101 0 00-.338-.751z" }))); };
var StyledSearch32 = styled_components_1.default(Search32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledSearch32;
var templateObject_1;
//# sourceMappingURL=Search32.js.map